/** @jsx jsx */
import { jsx } from "@emotion/core"

import useSiteMetadata from "../hooks/use-site-metadata"

export default function Header() {
  const meta = useSiteMetadata()
  return (
    <div
      css={{
        padding: 8,
        paddingTop: 24,
        paddingBottom: 0,
        color: "#333333",
        textAlign: "center",
        "span, a": {
          marginLeft: 12,
          marginRight: 12,
        },
      }}
    >
      <div>
        <a
          target="_blank"
          title="Github Profile"
          rel="noopener noreferrer"
          href="https://github.com/leocristofani"
          css={{ color: "#333333" }}
        >
          {meta.title}
        </a>{" "}
        &middot; <span>{meta.description}</span>
      </div>
    </div>
  )
}
